// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-container {
    width: 900px;
    margin: 20px;
}

h2 {
    margin-bottom: 10px;
}

table {
    width: 100%;
    border-collapse: collapse;
}

th {
    text-align: left;
    border-bottom: 2px solid #ddd;
    padding: 8px;
}

td {
    padding: 8px;
    border-bottom: 1px solid #ddd;
}

.top-align {
    vertical-align: top;
}

/* ✅ Only the setting name is italicized */
.italic {
    font-style: italic;
}

.last-edit {
    font-size: 0.6em;
    color: gray;
    margin-top: 2px;
    display: flex;
    align-items: center;
    gap: 5px;
}

/* Tooltip container */
.tooltip-container {
    display: inline-block;
    position: relative;
}

/* ✅ Default size for info icon */
.info-icon {
    cursor: pointer;
}

/* Tooltip text */
.tooltip-text {
    visibility: hidden;
    width: max-content;
    background-color: #333;
    color: #fff;
    text-align: center;
    padding: 5px;
    border-radius: 4px;
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translate(5px, -50%);
    white-space: nowrap;
}

/* Show tooltip on hover */
.tooltip-container:hover .tooltip-text {
    visibility: visible;
}

textarea {
    width: 100%;
    height: 100px;
}

.value-column {
    width: 60%;
}

.update-button {
    padding: 8px 14px;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    font-size: 1em;
}

.update-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

/* Highlight invalid inputs */
.invalid-input {
    border: 2px solid red;
    background-color: #ffe6e6;
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsEditor/SettingsEditor.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0CAA0C;AAC1C;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,sBAAsB;AACtB;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,iCAAiC;AACjC;IACI,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,qBAAqB;IACrB,yBAAyB;AAC7B","sourcesContent":[".settings-container {\n    width: 900px;\n    margin: 20px;\n}\n\nh2 {\n    margin-bottom: 10px;\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n}\n\nth {\n    text-align: left;\n    border-bottom: 2px solid #ddd;\n    padding: 8px;\n}\n\ntd {\n    padding: 8px;\n    border-bottom: 1px solid #ddd;\n}\n\n.top-align {\n    vertical-align: top;\n}\n\n/* ✅ Only the setting name is italicized */\n.italic {\n    font-style: italic;\n}\n\n.last-edit {\n    font-size: 0.6em;\n    color: gray;\n    margin-top: 2px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n/* Tooltip container */\n.tooltip-container {\n    display: inline-block;\n    position: relative;\n}\n\n/* ✅ Default size for info icon */\n.info-icon {\n    cursor: pointer;\n}\n\n/* Tooltip text */\n.tooltip-text {\n    visibility: hidden;\n    width: max-content;\n    background-color: #333;\n    color: #fff;\n    text-align: center;\n    padding: 5px;\n    border-radius: 4px;\n    position: absolute;\n    left: 100%;\n    top: 50%;\n    transform: translate(5px, -50%);\n    white-space: nowrap;\n}\n\n/* Show tooltip on hover */\n.tooltip-container:hover .tooltip-text {\n    visibility: visible;\n}\n\ntextarea {\n    width: 100%;\n    height: 100px;\n}\n\n.value-column {\n    width: 60%;\n}\n\n.update-button {\n    padding: 8px 14px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 4px;\n    font-size: 1em;\n}\n\n.update-button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n/* Highlight invalid inputs */\n.invalid-input {\n    border: 2px solid red;\n    background-color: #ffe6e6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
